import { render, staticRenderFns } from "./ManageReminders.vue?vue&type=template&id=9a15e274&scoped=true"
import script from "./ManageReminders.vue?vue&type=script&lang=js"
export * from "./ManageReminders.vue?vue&type=script&lang=js"
import style0 from "./ManageReminders.vue?vue&type=style&index=0&id=9a15e274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a15e274",
  null
  
)

export default component.exports